var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      widthClass: "max-1000",
      title: _vm.iSEdited
        ? _vm.$t("label_essweb_shiftType_form_editTitle")
        : _vm.$t("label_essweb_shiftType_form_viewTitle"),
      backgroundClass: "white",
      initData: _vm.shiftTypeData,
      checkData: [
        "shift_type_name",
        "shift_type_code",
        "shift_type_abbr",
        "shift_type_description",
        "sequence",
      ],
      editBtn: !_vm.iSEdited,
      delBtn: "",
    },
    on: {
      change: function (changed) {
        return (_vm.isChanged = changed)
      },
      delete: function ($event) {
        _vm
          .$confirmDo(_vm.$t("label_essweb_shiftType_list_title"))
          .then(function (res) {
            res ? _vm.toDelete() : null
          })
      },
      edit: function ($event) {
        _vm.iSEdited = true
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "100",
                            readonly: !_vm.iSEdited,
                            bindData: _vm.shiftTypeData.shift_type_name,
                            label: _vm.$t(
                              "label_essweb_shiftType_form_typeNameLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.shiftTypeData.shift_type_name = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            bindData: _vm.shiftTypeData.shift_type_abbr,
                            maxlength: "20",
                            label: _vm.$t(
                              "label_essweb_shiftType_form_typeAbbrLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.shiftTypeData.shift_type_abbr = valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            maxlength: "20",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            label: _vm.$t(
                              "label_essweb_ClaimReason_form_codeLabel"
                            ),
                          },
                          model: {
                            value: _vm.shiftTypeData.shift_type_code,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.shiftTypeData,
                                "shift_type_code",
                                $$v
                              )
                            },
                            expression: "shiftTypeData.shift_type_code",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "6",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("normalInputTextFiled", {
                          attrs: {
                            type: "number",
                            filled: _vm.iSEdited,
                            readonly: !_vm.iSEdited,
                            isNotRequire: "",
                            maxlength: "255",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 255]
                            ),
                            label: _vm.$t(
                              "label_essweb_shiftType_form_sequenceLabel"
                            ),
                          },
                          model: {
                            value: _vm.shiftTypeData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.shiftTypeData, "sequence", $$v)
                            },
                            expression: "shiftTypeData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            filled: _vm.iSEdited,
                            maxlength: "500",
                            readonly: !_vm.iSEdited,
                            bindData: _vm.shiftTypeData.shift_type_description,
                            label: _vm.$t(
                              "label_essweb_shiftType_form_descriptionLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.shiftTypeData.shift_type_description =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "page-actions",
        fn: function () {
          return [
            _vm.iSEdited
              ? _c("CardActions", {
                  attrs: { saveBtn: "" },
                  on: {
                    save: _vm.toSave,
                    cancel: function ($event) {
                      return _vm.toBack(_vm.isChanged)
                    },
                  },
                })
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return undefined
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }